import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const ThumbsDownIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 16 14", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} style={{ fontSize: 20 }} {...rest}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    transform="translate(-225.000000, -53.000000)"
                    fill="#33006E"
                    fillRule="nonzero"
                >
                    <g transform="translate(194.000000, 40.000000)">
                        <path
                            d="M31,27 L33.9090909,27 L33.9090909,18.6 L31,18.6 L31,27 Z M47,19.3 C47,18.53 46.3454545,17.9 45.5454545,17.9 L40.9636364,17.9 L41.6909091,14.68 C41.6909091,14.61 41.6909091,14.54 41.6909091,14.47 C41.6909091,14.19 41.5454545,13.91 41.4000285,13.7 L40.6,13 L35.8,17.62 C35.5090909,17.83 35.3636364,18.18 35.3636364,18.6 L35.3636364,25.6 C35.3636364,26.37 36.0181818,27 36.8181818,27 L43.3636364,27 C43.9454545,27 44.4545455,26.65 44.6727273,26.16 L46.8545455,21.1899725 C46.9272727,21.0499725 46.9272727,20.8399725 46.9272727,20.6999725 L46.9272727,19.2999725 L47,19.2999725 C47,19.37 47,19.3 47,19.3 Z"
                            transform="translate(39.000000, 20.000000) scale(-1, -1) translate(-39.000000, -20.000000) "
                        ></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
